import { render, staticRenderFns } from "./MultiSwitch.vue?vue&type=template&id=8fc6e5c6&scoped=true&"
import script from "./MultiSwitch.vue?vue&type=script&lang=js&"
export * from "./MultiSwitch.vue?vue&type=script&lang=js&"
import style0 from "./MultiSwitch.vue?vue&type=style&index=0&id=8fc6e5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc6e5c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
